import axios from "../../../../../../api/axiosInstance";
import { AutoMapAccountsResponse } from "./types";

export const autoMapAccounts = async (
  companyUuid: string,
  signal?: AbortSignal,
): Promise<AutoMapAccountsResponse> => {
  const response = await axios.post<AutoMapAccountsResponse>(
    `/api/private/companies/${companyUuid}/quickbooks/account-mappings/auto-map`,
    {},
    { signal },
  );
  return response.data;
};
